import React from 'react';
import { SVGProps } from './type';

const IconEditBorder = ({ fill }: SVGProps) => (
  <path
    d="M17.688 9.271L13.958 5.541L14.979 4.521C15.3263 4.17367 15.7397 4 16.219 4C16.6983 4 17.1113 4.17367 17.458 4.521L18.708 5.771C19.0413 6.10433 19.208 6.51733 19.208 7.01C19.208 7.50333 19.0413 7.91667 18.708 8.25L17.688 9.271ZM16.458 10.5L7.729 19.229H4V15.5L12.729 6.771L16.458 10.5Z"
    fill={fill}
  />
);

export default IconEditBorder;
